import React from 'react';

import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import HttpErrorAlert from '../../libs/sgx/components/HttpErrorAlert';

const CubejsCard = ({
    title, 
    children,
    error,
}) => {
    return (
        <Card>
            <CardContent>
                <Typography gutterBottom variant="h5" component="h2">
                    {title}
                </Typography>
                {error ? <HttpErrorAlert error={error}/> : children}
            </CardContent>
        </Card>
    );
}

export default CubejsCard;